'use strict';

var os = require('os');
if (typeof os.homedir !== 'undefined') {
  module.exports = os.homedir;
} else {
  module.exports = require('./polyfill.js');
}




//////////////////
// WEBPACK FOOTER
// ./node_modules/homedir-polyfill/index.js
// module id = 715
// module chunks = 3